import React from "react";

export const DatenschutzPage = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Hero-Bereich – optisch konsistent mit anderen Seiten */}
      <section className="relative py-24 md:py-32 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white overflow-hidden">
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute top-1/4 -left-20 w-96 h-96 bg-gradient-to-r from-purple-600/30 to-orange-500/30 rounded-full blur-3xl animate-float" />
          <div
            className="absolute bottom-1/4 -right-20 w-80 h-80 bg-gradient-to-r from-orange-500/30 to-purple-600/30 rounded-full blur-3xl animate-float"
            style={{ animationDelay: "-3s" }}
          />
        </div>

        <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-light text-white mb-6">
              <span className="gradient-text font-medium">Datenschutzerklärung</span>
              <br />
              Informationen zur Verarbeitung personenbezogener Daten
            </h1>
            <p className="text-sm md:text-base text-slate-200 max-w-3xl mx-auto leading-relaxed font-light">
              Diese Datenschutzerklärung informiert Sie darüber, wie{" "}
              <span className="font-medium">**[Firmenname / Marke, z.&nbsp;B. GLOBRIDGE]**</span>{" "}
              personenbezogene Daten beim Besuch der Website{" "}
              <span className="font-medium">
                **[vollständige Domain, z.&nbsp;B. www.globridge.de]**
              </span>{" "}
              und im Rahmen unserer Beratungs-, Coaching- und Trainingsleistungen verarbeitet.
            </p>
          </div>
        </div>
      </section>

      {/* Inhalt */}
      <section className="py-20 md:py-24 bg-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 space-y-12 text-sm md:text-base text-slate-700 leading-relaxed">
          {/* 1. Verantwortlicher */}
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">
              1. Verantwortlicher und Geltungsbereich
            </h2>
            <p>
              Verantwortlicher im Sinne der Datenschutz-Grundverordnung (DSGVO) ist:
            </p>
            <p className="mt-2">
              **[Firmenname / Marke, z.&nbsp;B. GLOBRIDGE]**
              <br />
              **[Rechtsform, z.&nbsp;B. Einzelunternehmen / GmbH / UG (haftungsbeschränkt)]**
              <br />
              **[Straße und Hausnummer]**
              <br />
              **[PLZ] [Ort]**
              <br />
              **[Land]**
            </p>
            <p className="mt-2">
              Telefon: **[geschäftliche Telefonnummer]**
              <br />
              E-Mail:{" "}
              <span className="break-all">
                **[geschäftliche E-Mail-Adresse, z.&nbsp;B. hello@globridge.com]**
              </span>
              <br />
              Website: **[Domain-URL]**
            </p>
            <p className="mt-4">
              Diese Datenschutzerklärung gilt für die oben genannte Website, alle
              Unterseiten sowie die darüber angebotenen Online-Services (z.&nbsp;B.
              Kontaktformular, Terminvereinbarungen, Online-Meetings, digitale Trainings
              und Programme).
            </p>
          </section>

          {/* 2. Datenschutz-Kontakt */}
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">
              2. Datenschutz-Kontakt
            </h2>
            <p>
              Für alle Fragen zum Datenschutz sowie zur Geltendmachung Ihrer Rechte
              können Sie sich an folgende Stelle wenden:
            </p>
            <p className="mt-2">
              **[Datenschutz-Kontakt, z.&nbsp;B. gleiche Anschrift wie oben]**
              <br />
              E-Mail:{" "}
              <span className="break-all">
                **[E-Mail-Adresse für Datenschutzanfragen, z.&nbsp;B. privacy@globridge.com]**
              </span>
            </p>
            <p className="mt-2">
              Sofern ein externer oder interner Datenschutzbeauftragter bestellt ist,
              ergänzen Sie hier bitte:
            </p>
            <p className="mt-2">
              Datenschutzbeauftragte/r: **[Name, falls vorhanden]**
              <br />
              Kontakt: **[Kontaktdaten Datenschutzbeauftragte/r]**
            </p>
          </section>

          {/* 3. Zielgruppe & B2B-Fokus */}
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">
              3. Zielgruppe des Angebots (B2B)
            </h2>
            <p>
              Die auf dieser Website dargestellten Leistungen (Beratung, Coaching,
              Trainings, TRIAX®-basierte Programme, CultureBridge MENA, Scrum4Sales,
              Change Sparring 6, Leadership Resonanz Atelier sowie SOS-Pakete) richten
              sich ausschließlich an Unternehmer im Sinne des §&nbsp;14 BGB, also
              Unternehmen, Organisationen, Körperschaften des öffentlichen Rechts und
              deren Organe bzw. Führungskräfte.
            </p>
            <p className="mt-2">
              Dennoch können im Rahmen der Kommunikation personenbezogene Daten
              natürlicher Personen (z.&nbsp;B. Ansprechpartner:innen in Unternehmen)
              verarbeitet werden. Für diese Verarbeitung gilt die DSGVO uneingeschränkt.
            </p>
          </section>

          {/* 4. Rechtsgrundlagen */}
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">
              4. Rechtsgrundlagen der Verarbeitung
            </h2>
            <p>
              Wir verarbeiten personenbezogene Daten ausschließlich im Rahmen der
              gesetzlichen Vorgaben, insbesondere der DSGVO und des BDSG. Je nach Art
              der Verarbeitung stützen wir uns insbesondere auf folgende
              Rechtsgrundlagen:
            </p>
            <ul className="list-disc ml-5 mt-2 space-y-1">
              <li>
                Art. 6 Abs. 1 lit. b DSGVO – Erfüllung eines Vertrags oder
                vorvertraglicher Maßnahmen
              </li>
              <li>
                Art. 6 Abs. 1 lit. f DSGVO – Wahrung berechtigter Interessen, z.&nbsp;B.
                Kommunikation mit Geschäftspartnern, IT-Sicherheit, Optimierung unseres
                Angebots
              </li>
              <li>
                Art. 6 Abs. 1 lit. c DSGVO – Erfüllung gesetzlicher Pflichten, z.&nbsp;B.
                handels- und steuerrechtliche Aufbewahrungspflichten
              </li>
              <li>
                Art. 6 Abs. 1 lit. a DSGVO – Einwilligung, sofern wir diese im Einzelfall
                gesondert einholen (z.&nbsp;B. für bestimmte Marketing-Mails)
              </li>
            </ul>
          </section>

          {/* 5. Hosting & Logfiles */}
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">
              5. Hosting und Server-Logfiles
            </h2>
            <p>
              Unsere Website wird bei folgendem Dienstleister (Hoster) betrieben:
            </p>
            <p className="mt-2">
              **[Hoster, z.&nbsp;B. Hostinger International Ltd., inkl. Anschrift wenn gewünscht]**
            </p>
            <p className="mt-2">
              Beim Aufruf unserer Website werden durch Ihren Browser automatisch
              bestimmte Informationen an den Server unseres Hosters übermittelt und
              temporär in sogenannten Server-Logfiles gespeichert. Dazu gehören
              insbesondere:
            </p>
            <ul className="list-disc ml-5 mt-2 space-y-1">
              <li>IP-Adresse des anfragenden Endgeräts</li>
              <li>Datum und Uhrzeit des Zugriffs</li>
              <li>Besuchte Seiten / abgerufene Dateien</li>
              <li>Übertragene Datenmenge</li>
              <li>Browsertyp und -version</li>
              <li>Betriebssystem des Endgeräts</li>
              <li>Referrer-URL (zuvor besuchte Seite, sofern übermittelt)</li>
            </ul>
            <p className="mt-2">
              Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO
              und dient der Sicherstellung eines technisch stabilen und sicheren
              Betriebs der Website (Betrieb, Sicherheit, Fehleranalyse).
            </p>
            <p className="mt-2">
              Die Logfiles werden in der Regel für einen Zeitraum von **[üblichen Zeitraum, z.&nbsp;B. 7–30 Tage]**
              gespeichert und anschließend gelöscht, soweit keine längere Aufbewahrung
              erforderlich ist (z.&nbsp;B. zur Aufklärung konkreter Sicherheitsvorfälle).
            </p>
          </section>

          {/* 6. Kontakt (Formular, E-Mail, Telefon) */}
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">
              6. Kontaktaufnahme (Formular, E-Mail, Telefon)
            </h2>
            <p>
              Wenn Sie uns per Kontaktformular, E-Mail oder telefonisch kontaktieren,
              verarbeiten wir die von Ihnen übermittelten personenbezogenen Daten (z.&nbsp;B.
              Name, Unternehmen, Funktion, Kontaktdaten, Inhalte der Nachricht) zur
              Bearbeitung Ihrer Anfrage und zur Anbahnung bzw. Durchführung einer
              Geschäftsbeziehung.
            </p>
            <p className="mt-2">
              Rechtsgrundlage ist in der Regel Art. 6 Abs. 1 lit. b DSGVO
              (vorvertragliche und vertragliche Kommunikation) sowie Art. 6 Abs. 1
              lit. f DSGVO (berechtigtes Interesse an effizienter Kommunikation mit
              Geschäftspartnern).
            </p>
            <p className="mt-2">
              Die im Rahmen von Anfragen verarbeiteten Daten speichern wir für die
              Dauer der Kommunikation sowie darüber hinaus, soweit gesetzliche
              Aufbewahrungspflichten bestehen oder die Daten für die Abwicklung einer
              Geschäftsbeziehung erforderlich sind.
            </p>
          </section>

          {/* 7. E-Mail-Dienst / EmailJS & ähnliche Tools */}
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">
              7. Versand von Nachrichten über externe E-Mail- und Formular-Dienste
            </h2>
            <p>
              Für den technischen Versand und die Verarbeitung von Kontaktanfragen
              können wir externe Dienste einsetzen, z.&nbsp;B.:
            </p>
            <p className="mt-2">
              **[Name des E-Mail-/Formulardienstes, z.&nbsp;B. EmailJS, inkl. Anbieterangaben]**
            </p>
            <p className="mt-2">
              Diese Dienste werden von uns als Auftragsverarbeiter gemäß Art. 28 DSGVO
              eingesetzt. Mit den jeweiligen Anbietern schließen wir
              Auftragsverarbeitungsverträge, die den Schutz Ihrer Daten im Rahmen der
              gesetzlichen Vorgaben sicherstellen.
            </p>
            <p className="mt-2">
              Je nach Sitz des Dienstleisters kann eine Übermittlung von Daten in
              Drittländer (z.&nbsp;B. USA) stattfinden. In diesem Fall stellen wir sicher,
              dass geeignete Garantien im Sinne der Art. 44 ff. DSGVO bestehen
              (z.&nbsp;B. Angemessenheitsbeschluss der EU-Kommission oder EU-Standardvertragsklauseln).
            </p>
          </section>

          {/* 8. Online-Meetings & Trainings */}
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">
              8. Online-Meetings, Coachings & Trainings (z.&nbsp;B. via Videokonferenz)
            </h2>
            <p>
              Für Online-Meetings, Coachings, Workshops und Trainings setzen wir
              gegebenenfalls Videokonferenz- und Kollaborationstools ein, z.&nbsp;B.:
            </p>
            <p className="mt-2">
              **[konkrete Tools eintragen, z.&nbsp;B. Zoom, Microsoft Teams, Google Meet, inkl. Anbieter]**
            </p>
            <p className="mt-2">
              Umfang und Art der verarbeiteten Daten hängen vom jeweiligen Tool sowie
              von Ihrer Nutzung ab und umfassen in der Regel:
            </p>
            <ul className="list-disc ml-5 mt-2 space-y-1">
              <li>Anzeige- / Profilname, E-Mail-Adresse, Unternehmen</li>
              <li>Meeting-Metadaten (Datum, Uhrzeit, Dauer)</li>
              <li>Kommunikationsinhalte (Audio, Video, Chatnachrichten)</li>
              <li>ggf. geteilte Bildschirm- und Präsentationsinhalte</li>
            </ul>
            <p className="mt-2">
              Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO (Durchführung vereinbarter
              Leistungen) sowie Art. 6 Abs. 1 lit. f DSGVO (effiziente und ortsunabhängige
              Zusammenarbeit).
            </p>
            <p className="mt-2">
              Bitte beachten Sie zudem die Datenschutzhinweise der jeweiligen
              Tool-Anbieter:
              <br />
              **[Links zu den Datenschutzerklärungen der eingesetzten Tools einfügen]**
            </p>
          </section>

          {/* 9. Newsletter & Direktkommunikation (optional) */}
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">
              9. Newsletter, Mailings & Direktkommunikation
            </h2>
            <p>
              Sofern wir in Zukunft Newsletter, regelmäßige Mailings oder vergleichbare
              Direktkommunikation anbieten, werden wir hierfür eine gesonderte
              Einwilligung gemäß Art. 6 Abs. 1 lit. a DSGVO einholen oder uns auf
              gesetzlich zulässige Formen der Direktwerbung gegenüber bestehenden
              Geschäftskunden stützen (Art. 6 Abs. 1 lit. f DSGVO i.V.m. § 7 UWG).
            </p>
            <p className="mt-2">
              Für Versand und Verwaltung solcher Mailings können wir spezialisierte
              Dienste nutzen, z.&nbsp;B.:
            </p>
            <p className="mt-2">
              **[Newsletter-Tool, z.&nbsp;B. Mailchimp / Brevo – nur eintragen, wenn wirklich genutzt]**
            </p>
            <p className="mt-2">
              Wenn derzeit kein Newsletter genutzt wird, kann dieser Abschnitt
              entsprechend angepasst oder entfernt werden.
            </p>
          </section>

          {/* 10. LinkedIn & Social Media */}
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">
              10. LinkedIn & andere Social-Media-Präsenzen
            </h2>
            <p>
              Wir unterhalten Präsenzen auf externen Plattformen, insbesondere auf
              LinkedIn, um mit bestehenden und potenziellen Geschäftspartnern zu
              kommunizieren und über unsere Leistungen zu informieren:
            </p>
            <p className="mt-2">
              LinkedIn-Unternehmensprofil: **[LinkedIn-URL, z.&nbsp;B. https://www.linkedin.com/company/globridge]**
            </p>
            <p className="mt-2">
              Bei Besuch dieser Profile gelten die Datenschutzbestimmungen der
              jeweiligen Plattformbetreiber. Je nach Plattform erfolgt eine
              gemeinsame Verantwortlichkeit im Sinne von Art. 26 DSGVO (insbesondere
              bei LinkedIn „Page Insights“).
            </p>
            <p className="mt-2">
              Bitte beachten Sie daher zusätzlich die jeweiligen Datenschutzhinweise
              der Plattform:
              <br />
              **[Link zur Datenschutzerklärung von LinkedIn und ggf. weiteren Plattformen]**
            </p>
          </section>

          {/* 11. Empfänger & Auftragsverarbeiter */}
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">
              11. Empfänger und Kategorien von Empfängern
            </h2>
            <p>
              Innerhalb unseres Unternehmens erhalten nur diejenigen Stellen Zugriff
              auf Ihre Daten, die diese zur Erfüllung unserer vertraglichen und
              gesetzlichen Pflichten benötigen.
            </p>
            <p className="mt-2">
              Darüber hinaus setzen wir externe Dienstleister als Auftragsverarbeiter
              ein, z.&nbsp;B. in den Bereichen:
            </p>
            <ul className="list-disc ml-5 mt-2 space-y-1">
              <li>Hosting und technische Bereitstellung der Website</li>
              <li>E-Mail- und Kommunikationsdienste</li>
              <li>Videokonferenz- und Kollaborationstools</li>
              <li>ggf. Newsletter- und Mailing-Tools</li>
              <li>IT-Support, Wartung und Beratung</li>
            </ul>
            <p className="mt-2">
              Mit allen Auftragsverarbeitern schließen wir Verträge gemäß Art. 28 DSGVO,
              die insbesondere Vertraulichkeit, Sicherheit und den zweckgebundenen
              Umgang mit personenbezogenen Daten sicherstellen.
            </p>
          </section>

          {/* 12. Drittlandübermittlungen */}
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">
              12. Datenübermittlung in Drittländer
            </h2>
            <p>
              Soweit wir Dienste von Anbietern einsetzen, deren Sitz sich außerhalb der
              Europäischen Union bzw. des Europäischen Wirtschaftsraums (EWR) befindet
              oder die Daten dort verarbeiten (z.&nbsp;B. bestimmte E-Mail-Dienste,
              Videokonferenz-Anbieter, Newsletter-Tools), kann eine Übermittlung in
              sogenannte Drittländer erfolgen.
            </p>
            <p className="mt-2">
              In diesen Fällen stellen wir sicher, dass ein angemessenes
              Datenschutzniveau im Sinne der Art. 44 ff. DSGVO besteht, insbesondere
              durch:
            </p>
            <ul className="list-disc ml-5 mt-2 space-y-1">
              <li>Angemessenheitsbeschlüsse der EU-Kommission oder</li>
              <li>
                Abschluss von EU-Standardvertragsklauseln mit zusätzlichen
                Schutzmaßnahmen
              </li>
            </ul>
          </section>

          {/* 13. Speicherdauer */}
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">
              13. Speicherdauer
            </h2>
            <p>
              Wir speichern personenbezogene Daten nur so lange, wie dies für die
              jeweiligen Zwecke erforderlich ist oder gesetzliche Aufbewahrungspflichten
              bestehen (z.&nbsp;B. nach Handels- und Steuerrecht in der Regel 6 bis 10 Jahre).
            </p>
            <p className="mt-2">
              Danach werden die Daten entsprechend den gesetzlichen Vorgaben gelöscht
              oder anonymisiert.
            </p>
          </section>

          {/* 14. Cookies & ähnliche Technologien */}
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">
              14. Cookies und ähnliche Technologien
            </h2>
            <p>
              Bei der Nutzung unserer Website können Cookies und ähnliche
              Technologien (z.&nbsp;B. Local Storage, Session Storage) zum Einsatz kommen.
              Dabei kann es sich sowohl um technisch notwendige Cookies als auch –
              sofern implementiert – um optionale Analyse- oder Marketing-Cookies
              handeln.
            </p>
            <p className="mt-2">
              Welche Cookies im Detail eingesetzt werden, hängt von Ihrer konkreten
              technischen Implementierung ab. Dieser Abschnitt ist daher an die
              tatsächliche Nutzung anzupassen:
            </p>
            <p className="mt-2">
              **[Beschreibung der aktuell eingesetzten Cookies / keine Tracking-Cookies /
              verwendetes Consent-Tool, falls vorhanden, hier eintragen]**
            </p>
            <p className="mt-2">
              Soweit wir für nicht technisch notwendige Cookies eine Einwilligung
              einholen, erfolgt die Verarbeitung auf Grundlage von Art. 6 Abs. 1 lit. a
              DSGVO. Technisch notwendige Cookies verarbeiten wir auf Grundlage von
              Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an dem technisch
              einwandfreien Betrieb der Website).
            </p>
          </section>

          {/* 15. Ihre Rechte */}
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">
              15. Ihre Rechte als betroffene Person
            </h2>
            <p>
              Ihnen stehen als betroffene Person im Rahmen der DSGVO insbesondere
              folgende Rechte zu:
            </p>
            <ul className="list-disc ml-5 mt-2 space-y-1">
              <li>Recht auf Auskunft (Art. 15 DSGVO)</li>
              <li>Recht auf Berichtigung (Art. 16 DSGVO)</li>
              <li>Recht auf Löschung (Art. 17 DSGVO)</li>
              <li>Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
              <li>Recht auf Datenübertragbarkeit (Art. 20 DSGVO)</li>
              <li>
                Widerspruchsrecht gegen Verarbeitungen auf Grundlage von Art. 6 Abs. 1
                lit. e oder f DSGVO (Art. 21 DSGVO)
              </li>
              <li>
                Recht, eine erteilte Einwilligung jederzeit mit Wirkung für die Zukunft
                zu widerrufen (Art. 7 Abs. 3 DSGVO)
              </li>
            </ul>
            <p className="mt-2">
              Zur Ausübung dieser Rechte können Sie sich jederzeit an die unter Ziffer 2
              genannten Kontaktdaten wenden.
            </p>
            <p className="mt-2">
              Zudem haben Sie das Recht, sich bei einer Datenschutzaufsichtsbehörde zu
              beschweren, wenn Sie der Ansicht sind, dass die Verarbeitung Ihrer
              personenbezogenen Daten gegen die DSGVO verstößt (Art. 77 DSGVO).
            </p>
          </section>

          {/* 16. Pflicht zur Bereitstellung */}
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">
              16. Pflicht zur Bereitstellung von Daten
            </h2>
            <p>
              Im Rahmen der Nutzung unserer Website besteht grundsätzlich keine
              gesetzliche oder vertragliche Pflicht, personenbezogene Daten
              bereitzustellen. Allerdings kann die Bereitstellung bestimmter Daten
              erforderlich sein, um unsere Leistungen in Anspruch zu nehmen (z.&nbsp;B.
              Kontaktdaten zur Beantwortung von Anfragen oder Durchführung von
              Verträgen).
            </p>
            <p className="mt-2">
              Wenn Sie die hierfür erforderlichen Daten nicht bereitstellen, kann es
              sein, dass wir Ihre Anfrage nicht bearbeiten oder bestimmte Leistungen
              nicht erbringen können.
            </p>
          </section>

          {/* 17. Datensicherheit */}
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">
              17. Datensicherheit
            </h2>
            <p>
              Wir treffen angemessene technische und organisatorische Maßnahmen, um
              personenbezogene Daten vor Verlust, Missbrauch, unbefugtem Zugriff,
              unbefugter Offenlegung, Veränderung oder Zerstörung zu schützen.
            </p>
            <p className="mt-2">
              Dazu gehören insbesondere verschlüsselte Verbindungen (HTTPS), Zugriffs-,
              Berechtigungs- und Löschkonzepte sowie die sorgfältige Auswahl unserer
              Dienstleister.
            </p>
          </section>

          {/* 18. Sprachversionen */}
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">
              18. Sprachversionen
            </h2>
            <p>
              Soweit diese Website oder rechtliche Hinweise in weiteren Sprachen
              (z.&nbsp;B. Englisch, Französisch, Arabisch) angeboten werden, dienen
              diese Versionen ausschließlich der besseren Verständlichkeit für
              internationale Nutzer:innen.
            </p>
            <p className="mt-2">
              Rechtlich maßgeblich ist ausschließlich die{" "}
              <span className="font-medium">deutsche</span> Fassung dieser
              Datenschutzerklärung und der übrigen Rechtstexte.
            </p>
          </section>

          {/* 19. Änderungen */}
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">
              19. Änderungen dieser Datenschutzerklärung
            </h2>
            <p>
              Wir behalten uns vor, diese Datenschutzerklärung bei Bedarf zu
              aktualisieren, insbesondere wenn neue gesetzliche oder technische
              Anforderungen entstehen oder wir unsere Leistungen anpassen.
            </p>
            <p className="mt-2">
              Stand dieser Datenschutzerklärung: **[Monat Jahr, z.&nbsp;B. November 2025]**
            </p>
          </section>
        </div>
      </section>
    </div>
  );
};
